import React, { FunctionComponent, useCallback } from 'react'
import cn from 'classnames'
import { Icon } from '@/icons'
import { MktuClassWord } from '@/services/Api/generated'
import styles from './Word.module.scss'

type WordProps = {
  word: MktuClassWord
  onRemoveWord?: (word: MktuClassWord) => void
}

export const Word: FunctionComponent<WordProps> = ({ word, onRemoveWord }) => {
  const remove = useCallback(() => {
    onRemoveWord?.(word)
  }, [onRemoveWord, word])

  return (
    <WordWrapper
      word={word.word}
      onClick={onRemoveWord != null ? remove : undefined}
    >
      <span className={styles.wordName}>{word.word}</span>
      {word.isNice ? <span className={styles.charNice}>N</span> : null}
    </WordWrapper>
  )
}

type WordWrapperProps = React.PropsWithChildren<{
  word: MktuClassWord['word']
  onClick?: () => void
}>

const WordWrapper: FunctionComponent<WordWrapperProps> = ({
  word,
  onClick,
  children,
}) => {
  return onClick != null ? (
    <button
      type="button"
      className={cn(styles.position, styles.deletablePosition)}
      title={word}
      aria-label={`Удалить позицию: ${word}`}
      onClick={onClick}
    >
      {children}
      <Icon name="x" className={styles.removeWordIcon} />
    </button>
  ) : (
    <div className={styles.position} title={word}>
      {children}
    </div>
  )
}
